var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPlaying),expression:"isPlaying"}],staticClass:"gift-animation-overlay"},[_c('canvas',{ref:"riveCanvas",attrs:{"width":"400","height":"400"}})])}
var staticRenderFns = []

export { render, staticRenderFns }